// extracted by mini-css-extract-plugin
export default {"tag":"EnvironmentsString_tag__hEDpF"};